export default __webpack_public_path__ + "static/media/co2.a0125e6c.png";